export const SET_EMAIL_SENDERS = 'emailConfig/set-email-sender-list';
export const REMOVE_EMAIL_SENDER = 'emailConfig/remove-email-sender';
